export default __webpack_public_path__ + "static/media/dashboard.b11b53a2.svg";